
















import Vue from "vue";

export default Vue.extend({


	props: {
		subTitle: String,
		editMode: Boolean,
	},

	data() {
		return {
			editing: false
		}
	},

	computed: {
		title():string {
			let name = this.$store.state.map.name;
			if(!this.editing) {
				
					if(!name) {
						name = "Mitt Midnattslopp";
					}
					name += " (" + this.$store.getters.trackLength.toFixed(1) + " km)";
			}
			return name;
		}
	},

	methods: {
		updateName(event) {
			this.$store.state.map.name = event.target.value;
			this.editing = false;
		},

		setEditing() {
			if(this.editMode) {
				this.editing = true;
				Vue.nextTick(() => {
					(this.$refs.inp as HTMLInputElement).focus();
					(this.$refs.inp as HTMLInputElement).select();
				})
			}
		}
	}

})
